<div class="main-item__title">{{ event.name }}</div>

<div class="main-item__categories" *ngIf="event.categories?.length > 0">
    <mat-chip-list aria-label="Categories">
        <mat-chip *ngFor="let category of event.categories">{{ category }}</mat-chip>
    </mat-chip-list>
</div>

<div class="main-item__description" [innerHTML]="event.description" *ngIf="event.description"></div>
